import { render } from "./CalculationsByProductHistory.vue?vue&type=template&id=2ac45816"
import script from "./CalculationsByProductHistory.vue?vue&type=script&lang=ts"
export * from "./CalculationsByProductHistory.vue?vue&type=script&lang=ts"
script.render = render

export default script